import React from 'react';
import { Dropdown } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import translation from '../../i18n/en';

import { switchLanguage, getLanguage } from '../../features/language/languageSlice';
const LanguageSwitcher = () => {

  const { t } = useTranslation();

  const dispatch = useDispatch();

  const languageState = useSelector(getLanguage);

  const changeLanguage = (e) => {
    const desiredLanguage = e.currentTarget.dataset.language;
    dispatch(switchLanguage(desiredLanguage));
  }

  let selectedOption;
  const currentLanguage = languageState.language || 'en';

  selectedOption = <>{t('languages:' + currentLanguage, { lng: currentLanguage })}</>

  return (
    <>
      <Dropdown drop="up">
        <Dropdown.Toggle variant="" id="selLanguage" className="my-2 mx-2">
          {selectedOption}
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-menu-up">
          {Object.keys(translation.languages).map(languageCode =>

            <li key={languageCode}>
              <Dropdown.Item className="dropdown-item" data-language={languageCode} onClick={changeLanguage}>
                {t('languages:' + languageCode, { lng: languageCode })}
              </Dropdown.Item>
            </li>

          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default LanguageSwitcher;